<!--<form #registerForm="ngForm" (ngSubmit)="onSubmit()">-->
<!--  <div class="flex sm:h-screen">-->
<!--    <div class="hidden lg:flex h-full flex-column bg-primary p-4" style="width: 58vw; max-width: 480px">-->
<!--      <div class="flex align-items-center gap-3">-->
<!--        <img style="width: 40px; height: 40px" src="assets/icons/icon-main-logo-white.png" alt="main-logo-white" />-->
<!--        <p class="text-white font-semibold">AIFLOW CRM</p>-->
<!--      </div>-->
<!--      <div class="flex flex-column gap-3 align-items-center justify-content-center h-full">-->
<!--        <img style="width: 360px" src="assets/images/img-register-banner.png" alt="banner" />-->
<!--        <p *appHiddenProd class="text-4xl tect-color font-semibold">{{ 'register.left_bar.header' | transloco }}</p>-->
<!--        <p *appHiddenProd class="text-xs tect-color font-normal">-->
<!--          {{ 'register.left_bar.sub_header' | transloco }}-->
<!--        </p>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="flex flex-column justify-content-center align-items-center w-full">-->
<!--      <div class="flex justify-content-end w-full p-3"><app-language-config></app-language-config></div>-->

<!--      <div class="flex flex-1 flex-column justify-content-center gap-6 w-full sm:w-9 px-4 pb-4">-->
<!--        <div class="flex flex-column gap-3">-->
<!--          <p class="text-4xl tect-color font-semibold">{{ 'register.header' | transloco }}</p>-->
<!--          <p *appHiddenProd class="text-xs tect-color text-400">{{ 'register.sub_header' | transloco }}</p>-->
<!--        </div>-->
<!--        <div class="flex flex-column gap-3 sm:gap-5">-->
<!--          <div class="flex flex-column sm:flex-row gap-3">-->
<!--            <div class="flex flex-column gap-2 w-full">-->
<!--              <label class="text-sm text-color font-normal" for="firstName">-->
<!--                {{ 'first_name' | transloco }}-->
<!--                <span class="text-red-600">*</span>-->
<!--              </label>-->
<!--              <input-->
<!--                pInputText-->
<!--                id="firstName"-->
<!--                name="firstName"-->
<!--                [(ngModel)]="formRegisterSignal().firstName"-->
<!--                [appNoneSpecialChar]="true"-->
<!--                required-->
<!--              />-->
<!--            </div>-->
<!--            <div class="flex flex-column gap-2 w-full">-->
<!--              <label class="text-sm text-color font-normal" for="lastName">-->
<!--                {{ 'last_name' | transloco }}-->
<!--                <span class="text-red-600">*</span>-->
<!--              </label>-->
<!--              <input-->
<!--                pInputText-->
<!--                id="lastName"-->
<!--                name="lastName"-->
<!--                [(ngModel)]="formRegisterSignal().lastName"-->
<!--                [appNoneSpecialChar]="true"-->
<!--                required-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="flex flex-column gap-2 w-full">-->
<!--            <label class="text-sm text-color font-normal" for="email">-->
<!--              {{ 'e-mail' | transloco }}-->
<!--              <span class="text-red-600">*</span>-->
<!--            </label>-->
<!--            <input pInputText type="email" id="email" name="email" [(ngModel)]="formRegisterSignal().email" [email]="true" required />-->
<!--          </div>-->
<!--          &lt;!&ndash; FIXME - When need a password &ndash;&gt;-->
<!--          &lt;!&ndash; <div class="relative flex flex-column gap-2 w-full">-->
<!--            <label class="text-sm text-color font-normal" for="password">-->
<!--              {{ 'register.form.password' | transloco }}-->
<!--              <span class="text-red-600">*</span>-->
<!--            </label>-->
<!--            <p-password-->
<!--              inputId="password"-->
<!--              name="password"-->
<!--              styleClass="w-full"-->
<!--              inputStyleClass="w-full"-->
<!--              [feedback]="false"-->
<!--              [toggleMask]="true"-->
<!--              [(ngModel)]="formRegisterSignal().password"-->
<!--              pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}$"-->
<!--              (input)="onChangePassword($event, registerForm.form)"-->
<!--              required-->
<!--            />-->

<!--            <div class="absolute flex text-xs text-red-600 font-normal" style="bottom: -1.5rem">-->
<!--              @if (registerForm.form.get('password')?.dirty) {-->
<!--                @if (!formRegisterSignal().password.match('(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(.{8,})')) {-->
<!--                  <p>{{ 'register.validate.password_must_have_at_least_8_characters' | transloco }}</p>-->
<!--                }-->
<!--                @if (!formRegisterSignal().password.match('(?=.*[A-Z])(?=.*[a-z])')) {-->
<!--                  <p>-->
<!--                    @if (!formRegisterSignal().password.match('(.{8,})')) {-->
<!--                      <span>,</span>-->
<!--                    }-->
<!--                    {{ 'register.validate.uppercase_lowercase_letters' | transloco }}-->
<!--                  </p>-->
<!--                }-->
<!--                @if (!formRegisterSignal().password.match('(?=.*\\d)')) {-->
<!--                  <p>-->
<!--                    @if (!formRegisterSignal().password.match('(?=.*[A-Z])(?=.*[a-z])(.{8,})')) {-->
<!--                      <span>,</span>-->
<!--                    }-->
<!--                    {{ 'register.validate.numbers' | transloco }}-->
<!--                  </p>-->
<!--                }-->
<!--              }-->
<!--            </div>-->
<!--          </div> &ndash;&gt;-->
<!--          &lt;!&ndash; FIXME - When need confirm password &ndash;&gt;-->
<!--          &lt;!&ndash; <div class="relative flex flex-column gap-2 w-full">-->
<!--            <label class="text-sm text-color font-normal" for="confirmPassword">-->
<!--              {{ 'register.form.confirm_password' | transloco }}-->
<!--              <span class="text-red-600">*</span>-->
<!--            </label>-->
<!--            <p-password-->
<!--              inputId="confirmPassword"-->
<!--              name="confirmPassword"-->
<!--              styleClass="w-full"-->
<!--              [inputStyleClass]="!validConfirmPassword() ? 'w-full ng-invalid ng-dirty' : 'w-full'"-->
<!--              [feedback]="false"-->
<!--              [toggleMask]="true"-->
<!--              [(ngModel)]="formRegisterSignal().confirmPassword"-->
<!--              (input)="onChangeConfirmPassword($event)"-->
<!--              required-->
<!--            />-->

<!--            <div class="absolute text-xs text-red-600 font-normal" style="bottom: -1.5rem">-->
<!--              @if (!validConfirmPassword()) {-->
<!--                <p>{{ 'register.validate.passwword_must_match' | transloco }}</p>-->
<!--              }-->
<!--            </div>-->
<!--          </div> &ndash;&gt;-->
<!--        </div>-->
<!--        <p-button-->
<!--          type="submit"-->
<!--          [label]="'register.register_button' | transloco"-->
<!--          [loading]="loadingButtonSignal()"-->
<!--          [disabled]="!disableBtn(registerForm.form)"-->
<!--          styleClass="w-full"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</form>-->

<!--new ui-->
<section class="register-page">
  <img src="/assets/images/register-cover.png" alt="register-img" class="register-cover" />
  <section class="register-form-container">
    <div class="btn-language-position"><app-language-config></app-language-config></div>
    <div class="p-4">
      <div class="header-register">
        <img src="/assets/icons/icon-main-logo.svg" alt="" width="48px" />
        <h1 class="title-register">{{ 'register.header' | transloco }}</h1>
        <!--        <p class="sub-title-register">{{ 'register.sub_title' | transloco }}</p>-->
      </div>
      <form action="" method="post" #registerForm="ngForm" (ngSubmit)="onSubmit()">
        <fieldset>
          <legend>{{ 'register.title' | transloco }}</legend>

          <div class="name-input">
            <div class="register-layout">
              <label for="firstName">
                {{ 'first_name' | transloco }}
                <span class="clr-red">*</span>
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                [(ngModel)]="formRegisterSignal().firstName"
                [appNoneSpecialChar]="true"
                required
              />
            </div>

            <div class="register-layout">
              <label for="lastName">
                {{ 'last_name' | transloco }}
                <span class="clr-red">*</span>
              </label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                [(ngModel)]="formRegisterSignal().lastName"
                [appNoneSpecialChar]="true"
                required
              />
            </div>
          </div>

          <div class="register-layout">
            <label for="email">
              {{ 'e-mail' | transloco }}
              <span class="clr-red">*</span>
            </label>
            <input type="email" id="email" name="email" [(ngModel)]="formRegisterSignal().email" [email]="true" required />
          </div>

          <p-button
            type="submit"
            [label]="'register.register_button' | transloco"
            [loading]="loadingButtonSignal()"
            [disabled]="!disableBtn(registerForm.form)"
            styleClass="w-full"
          />
        </fieldset>
      </form>
    </div>
    <div></div>
  </section>
</section>

<app-dialog-alert [dataDialog]="dialogSignal()" (OnHide)="onCloseDialog()"></app-dialog-alert>
